import useScrollIntoView from '@/hooks/useValidateAddress/useScrollIntoView';
import Label from '@/ui/members/components/form/Label';
import { focusClasses } from '@/ui/members/components/form/styles';

import { Props } from './types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const TextArea = ({
  autoCorrect = 'on',
  autoFocus = false,
  cols = 30,
  disabled = false,
  id,
  labelText,
  name,
  onBlur,
  onChange,
  placeholder,
  readOnly = false,
  rows = 4,
  spellCheck = true,
  scrollIntoView = true,
  value
}: Props) => {
  const handleFocus = useScrollIntoView({
    enabled: scrollIntoView,
    offset: 0
  });

  return (
    <>
      {labelText && <Label htmlFor={id} text={labelText} />}
      <textarea
        autoCorrect={autoCorrect}
        autoFocus={autoFocus}
        className={`dark:bg-uniform-gray-700 dark:text-uniform-white-base dark:placeholder:text-uniform-gray-300 light:bg-uniform-gray-100 light:text-uniform-gray-900 light:placeholder:text-uniform-gray-400 block w-full rounded-md border-0 p-4 ${focusClasses} sm:text-sm sm:leading-6`}
        cols={cols}
        disabled={disabled}
        id={id}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        placeholder={placeholder || labelText}
        readOnly={readOnly}
        rows={rows}
        spellCheck={spellCheck}
        value={value}
        onFocus={handleFocus}
      />
    </>
  );
};

export default TextArea;
